import { BimDataCredentialsInterface } from '../interfaces/bim-data-credentials.interface';

export class BimDataCredentials {
  /**
   * User token.
   */
  public token: string;

  /**
   * ProjectId.
   */
  public projectId: number;

  /**
   * Cloud Id.
   */
  public cloudId: number;

  /**
   *
   * @param data Data.
   */
  constructor(data: BimDataCredentialsInterface) {
    this.projectId = data.projectId;
    this.cloudId = data.cloudId;
    this.token = data.token;
  }
}
